const workerListGridConfig = {
    columns: [
        {
            id: 1,
            width: 250,
            selector: 'name',
            name: 'Име',
            sequenceNumber: 1,
            type: 'string'
        },
        {
            id: 2,
            width: 300,
            selector: 'location',
            name: 'Локация',
            sequenceNumber: 2,
            type: 'string'
        },
        {
            id: 3,
            width: 150,
            selector: 'countryIso',
            name: 'ISO',
            sequenceNumber: 3,
            type: 'string'
        }
    ],
    props: {
        headerRowHeight: 50,
        rowHeight: 52,
        tableHeight: 600,
        filterable: true,
        selectableColumn: {
            show: true,
            icon: 'fas fa-info-circle',
            width: 90
        }
    }
};

export default workerListGridConfig;